// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.adg3-editor
	#update-page-restrictions-dialog
	.aui-dialog2-content
	.restrictions-dialog-option
	.aui-iconfont-unlocked:before,
.adg3-editor
	.page-restrictions-dialog-drop-down
	.select2-results
	.restrictions-dialog-option
	.aui-iconfont-unlocked:before {
	font-family: 'ADG3-Editor-Icons', 'Atlassian Icons';
	font-size: 24px;
	content: '\\f1a9';
	margin-top: -13px;
}

.adg3-editor
	#update-page-restrictions-dialog
	.aui-dialog2-content
	.restrictions-dialog-option
	.aui-iconfont-locked:before,
.adg3-editor
	.page-restrictions-dialog-drop-down
	.select2-results
	.restrictions-dialog-option
	.aui-iconfont-locked:before {
	font-family: 'ADG3-Editor-Icons', 'Atlassian Icons';
	font-size: 24px;
	content: '\\f179';
	margin-top: -13px;
}
`, "",{"version":3,"sources":["webpack://./../confluence-editor/src/adg3-styles/view-page.css"],"names":[],"mappings":"AAAA;;;;;;;;;;CAUC,mDAAmD;CACnD,eAAe;CACf,gBAAgB;CAChB,iBAAiB;AAClB;;AAEA;;;;;;;;;;CAUC,mDAAmD;CACnD,eAAe;CACf,gBAAgB;CAChB,iBAAiB;AAClB","sourcesContent":[".adg3-editor\n\t#update-page-restrictions-dialog\n\t.aui-dialog2-content\n\t.restrictions-dialog-option\n\t.aui-iconfont-unlocked:before,\n.adg3-editor\n\t.page-restrictions-dialog-drop-down\n\t.select2-results\n\t.restrictions-dialog-option\n\t.aui-iconfont-unlocked:before {\n\tfont-family: 'ADG3-Editor-Icons', 'Atlassian Icons';\n\tfont-size: 24px;\n\tcontent: '\\f1a9';\n\tmargin-top: -13px;\n}\n\n.adg3-editor\n\t#update-page-restrictions-dialog\n\t.aui-dialog2-content\n\t.restrictions-dialog-option\n\t.aui-iconfont-locked:before,\n.adg3-editor\n\t.page-restrictions-dialog-drop-down\n\t.select2-results\n\t.restrictions-dialog-option\n\t.aui-iconfont-locked:before {\n\tfont-family: 'ADG3-Editor-Icons', 'Atlassian Icons';\n\tfont-size: 24px;\n\tcontent: '\\f179';\n\tmargin-top: -13px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
